import axios from "axios";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { baseURL } from '../utils/config';
const swal = require('sweetalert2');

const useAxios = () => {
  const { authTokens, setUser, setAuthTokens, logoutUser } = useContext(AuthContext);

  const axiosInstance = axios.create({
    baseURL,
    headers: { Authorization: `Bearer ${authTokens?.access}` }
  });

  // ─── Intercepteur REQUEST (refresh si access expiré) ──────────────────
  axiosInstance.interceptors.request.use(async req => {
    const user = jwtDecode(authTokens.access);
    const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
    if (!isExpired) return req;

    try {
      const response = await axios.post(`${baseURL}/token/refresh/`, {
        refresh: authTokens.refresh
      });
      localStorage.setItem("authTokens", JSON.stringify(response.data));
      setAuthTokens(response.data);
      setUser(jwtDecode(response.data.access));
      req.headers.Authorization = `Bearer ${response.data.access}`;
      return req;

    } catch (error) {
      // Le refresh token est lui aussi expiré → session terminée
      await swal.fire({
        title: "Session expirée",
        text: "Votre session a expiré. Veuillez vous reconnecter.",
        icon: "warning",
        confirmButtonText: "Se reconnecter",
        confirmButtonColor: "#1B019B",
        allowOutsideClick: false,
      });
      logoutUser();
      return Promise.reject(error);
    }
  });

  // ─── Intercepteur RESPONSE (cas 401 inattendu) ────────────────────────
  axiosInstance.interceptors.response.use(
    res => res,
    async error => {
      if (error.response?.status === 401) {
        await swal.fire({
          title: "Session expirée",
          text: "Votre session a expiré. Veuillez vous reconnecter.",
          icon: "warning",
          confirmButtonText: "Se reconnecter",
          confirmButtonColor: "#1B019B",
          allowOutsideClick: false,
        });
        logoutUser();
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxios;